import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { CollapsibleCode } from './CollapsibleCode';

interface Props {
  text: string;
}

export function Markdown({ text }: Props) {
  return (
    <div className="prose-xoro">
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        components={{
          a: ({ href, children, ...rest }) => (
            <a href={href} target="_blank" rel="noreferrer noopener" {...rest}>
              {children}
            </a>
          ),
          // react-markdown wraps code fences in <pre><code>. Replace the <pre>
          // entirely so we own the chrome (header + collapse) cleanly.
          pre({ children }) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const childAny = children as any;
            const codeNode = Array.isArray(childAny) ? childAny[0] : childAny;
            const className: string = codeNode?.props?.className ?? '';
            const match = /language-(\w+)/.exec(className);
            const raw = String(codeNode?.props?.children ?? '').replace(/\n$/, '');
            return <CollapsibleCode code={raw} language={match?.[1] ?? 'text'} />;
          },
          code({ className, children }) {
            // inline code only (block code is handled by `pre` above)
            return <code className={className}>{children}</code>;
          },
        }}
      >
        {text}
      </ReactMarkdown>
    </div>
  );
}
